export const CheckIfUserUsingBlocker = () => {
  //@ts-ignore
  return window.moneyOverAnything === undefined ? true : false;
};
